import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import * as auth from "../../store/ducks/auth.duck";
import * as utils from "../../../_metronic/utils/utils";
import axios from "axios";
import { Constants } from "../../utils/Constants";
import { toAbsoluteUrl } from "../../../_metronic";

const baseUrlSso = `${Constants.baseUrl}/auth-sso`;

const safeLocalStorageSet = (key, value) => {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (e) {
    console.warn(`Falha ao salvar ${key} no localStorage:`, e);
    return false;
  }
};

const clearPreviousSession = () => {
  const keysToRemove = [
    "authToken",
    "timeZone",
    "impersonation_active",
    "impersonation_session_id",
    "impersonation_expires_at",
    "impersonation_requester",
    "impersonation_approver",
    "impersonation_merchant",
  ];

  keysToRemove.forEach((key) => {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.warn(`Falha ao remover ${key} do localStorage:`, e);
    }
  });
};

const IMPERSONATION_DATA = {
  impersonation_active: () => "true",
  impersonation_session_id: (data) => data.session_id,
  impersonation_expires_at: (data) => data.expires_at,
  impersonation_requester: (data) => JSON.stringify(data.requester),
  impersonation_approver: (data) => JSON.stringify(data.approver),
  impersonation_merchant: (data) => JSON.stringify(data.merchant),
};

const storeImpersonationData = (impersonation) => {
  if (!impersonation) return;

  Object.entries(IMPERSONATION_DATA).forEach(([key, getValue]) => {
    safeLocalStorageSet(key, getValue(impersonation));
  });
};

function SsoAuth(props) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    authenticateWithToken();
  }, []);

  const authenticateWithToken = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");

    if (!token) {
      setError("Token de autenticação não fornecido");
      setLoading(false);
      return;
    }

    try {
      clearPreviousSession();

      const response = await axios.post(baseUrlSso, { token });

      if (!response.data) {
        throw new Error("Resposta inválida do servidor");
      }

      const authData = response.data;

      utils.setStorage("authToken", authData.token, null);
      safeLocalStorageSet("timeZone", authData.user?.empresa?.emp_fuso);
      storeImpersonationData(authData.impersonation);

      props.login(authData);
    } catch (err) {
      console.error("Erro ao autenticar com token:", err);
      setError(
        err.response?.data?.errors?.[0] ||
          err.response?.data?.message ||
          "Erro ao autenticar. Token inválido ou expirado."
      );
      setLoading(false);
    }
  };

  const renderMessage = (
    title,
    message = null,
    titleColor = null,
    showSpinner = false
  ) => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          maxWidth: "400px",
          width: "100%",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "32px" }}>
          <img
            alt="Logo"
            src={toAbsoluteUrl("/images/new_logo.png")}
            style={{ height: "40px" }}
          />
        </div>
        <h3
          style={
            titleColor
              ? { color: titleColor, textAlign: "center", marginBottom: "16px" }
              : { textAlign: "center", marginBottom: "16px" }
          }
        >
          {title}
        </h3>
        {message && (
          <p style={{ textAlign: "center", color: "#666", fontSize: "14px" }}>
            {message}
          </p>
        )}
        {showSpinner && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "24px",
            }}
          >
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Carregando...</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );

  if (loading) {
    return renderMessage("Autenticando...", null, null, true);
  }

  if (error) {
    return renderMessage("Erro na autenticação", error, "#f64e60", false);
  }

  return null;
}

export default connect(null, auth.actions)(SsoAuth);
